import { MutationTree } from 'vuex';
import { AccountsState } from './types';

export const mutations: MutationTree<AccountsState> = {
    setAccounts:(state, data) => {
        state.accounts = data
    },
    setAccountItem:(state, data) => {
        state.accountItem = data
    },
};